import { useId } from "react";
import { useSiteConfig } from "../config/SiteConfigContext";

/**
 * Consenso FACOLTATIVO del GDPR: finalità E) marketing diretto, F) profilazione.
 *
 * Checkbox nativa controllata dal chiamante, che la fa partire da `false`. Non è
 * `required` e non dipende da nessun altro consenso: il form si invia con
 * qualsiasi combinazione. Il testo è una <label> collegata all'input, quindi si
 * spunta anche cliccando la frase, e con la tastiera (Tab, poi Spazio) come ogni
 * checkbox.
 */
export function ConsentCheckbox({
  name,
  label,
  checked,
  onChange,
}: {
  name: "marketing_consent" | "profiling_consent";
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}) {
  const id = useId();
  const cfg = useSiteConfig();
  return (
    <div style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
      <input
        id={id}
        type="checkbox"
        name={name}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        style={{ accentColor: cfg.color_dark, width: 16, height: 16, margin: "2px 0 0", flexShrink: 0, cursor: "pointer" }}
      />
      <label htmlFor={id} style={{ fontSize: 13, lineHeight: 1.5, color: cfg.color_dark, cursor: "pointer" }}>
        {label}
      </label>
    </div>
  );
}
